import React from "react";
import styles from "../../DeviceHealth/FrequencyBucketTable.module.css";
import layerTableStyles from "./LayerLatencyTable.module.css";
import { LATENCY_BUCKETS, formatPercent, getPercentTone } from "./latencyBuckets";

// Shared by the Layer-wise latency table (city / depot rows) and its VIN popover.

const TONE_CLASS = {
    green: layerTableStyles.tone_green,
    yellow: layerTableStyles.tone_yellow,
    amber: layerTableStyles.tone_amber,
    red: layerTableStyles.tone_red,
    grey: layerTableStyles.tone_grey
};

export const displayValue = (val) =>
    val === null || val === undefined || val === "" ? "-" : val;

function PercentCell({ value }) {
    return (
        <td className={`${styles.bucketCell} ${TONE_CLASS[getPercentTone(value)]}`}>
            {formatPercent(value)}
        </td>
    );
}

// Actual % · latency buckets · Overall % cells of one row (VIN rows hide Actual %)
export default function LayerMetricCells({ row, showActualPct = true }) {
    return (
        <>
            {showActualPct && <PercentCell value={row.actualPct} />}
            {LATENCY_BUCKETS.map((b) => {
                const value = row[b.field];
                return (
                    <td
                        key={b.field}
                        className={`${styles.bucketCell} ${Number(value) ? TONE_CLASS[b.tone] : TONE_CLASS.grey}`}
                    >
                        {displayValue(value)} 
                    </td>
                );
            })}
            <PercentCell value={row.overallPct} />
        </>
    );
}

// two-row header: fixed columns, "Latency buckets" group, Overall % (L1 → L3)
export function LayerLatencyHeader({ firstColumns, layerStyles, showActualPct = true }) {
    return (
        <thead className="sticky-top">
            <tr>
                {firstColumns.map((c) => <th key={c} rowSpan={2}>{c}</th>)}
                {showActualPct && <th rowSpan={2}>Actual %</th>}
                <th colSpan={LATENCY_BUCKETS.length} className={layerStyles.groupHeader}>
                    Latency buckets
                </th>
                <th rowSpan={2} title="Percentage of messages received within 30 seconds">
                    Overall %<span className={layerStyles.headerHint}>L1 → L3</span>
                </th>
            </tr>
            <tr>
                {LATENCY_BUCKETS.map((b) => (
                    <th key={b.field} className={layerStyles.subHeader}>{b.label}</th>
                ))}
            </tr>
        </thead>
    );
}
